<template>
  <div class="create">
    <div class="header-timeline">
      <a-steps :current="1">
        <a-step title="填写职位信息" />
        <a-step title="选择职位服务" />
        <a-step title="填写推广信息" />
        <a-step title="发布职位" />
      </a-steps>
    </div>
    <div class="content">
      <a-form
        :form="form"
        :label-col="{ span: 2 }"
        :wrapper-col="{ span: 8 }"
        @submit="handleSubmit"
      >
        <template v-if="job_attribute === '2'">
          <DividerBar text="招聘快服务"></DividerBar>
          <a-form-item :wrapper-col="{ span: 24 }">
            <a-radio-group
              class="service-type"
              v-decorator="[
                'recruit_service_type',
                {
                  rules: [{ required: true, message: '请选择招聘快服务类型' }],
                },
              ]"
            >
              <a-radio :value="1" style="margin-right: 20px">
                <div
                  style="
                    display: flex;
                    justify-content: space-around;
                    flex-direction: start;
                  "
                >
                  <img class="item-img" src="@/assets/service1.png" />
                  <div class="item-text" style="margin-left: -150px">
                    面试快
                  </div>
                </div>
                <div style="margin-top: 20px">
                  <div
                    style="font-size: 14px; color: #9da7ae; line-height: 17px"
                  >
                    针对企业需要候选人快速到场面试
                  </div>
                  <span
                    style="font-size: 14px; color: #9da7ae; line-height: 17px"
                    >候选人一旦通过面试环节，猎头即可获得佣金奖励</span
                  >
                </div>
              </a-radio>
              <a-radio :value="2" style="margin-right: 20px">
                <div
                  style="
                    display: flex;
                    justify-content: space-around;
                    flex-direction: start;
                  "
                >
                  <img class="item-img" src="@/assets/service2.png" />
                  <div class="item-text" style="margin-left: -150px">
                    入职快
                  </div>
                </div>
                <div style="margin-top: 20px">
                  <div
                    style="font-size: 14px; color: #9da7ae; line-height: 17px"
                  >
                    针对企业需候选人快速入职公司
                  </div>
                  <span
                    style="font-size: 14px; color: #9da7ae; line-height: 17px"
                    >候选人一旦入职公司成功，猎头即可获得佣金奖励</span
                  >
                </div>
              </a-radio>
              <a-radio :value="3">
                <div
                  style="
                    display: flex;
                    justify-content: space-around;
                    flex-direction: start;
                  "
                >
                  <img class="item-img" src="@/assets/service3.png" />
                  <div class="item-text" style="margin-left: -150px">
                    过保快
                  </div>
                </div>
                <div style="margin-top: 20px">
                  <div
                    style="font-size: 14px; color: #9da7ae; line-height: 17px"
                  >
                    针对企业需候选人入职成功并顺利通过保证期
                  </div>
                  <span
                    style="font-size: 14px; color: #9da7ae; line-height: 17px"
                    >候选人一旦顺利通过保证期，猎头即可获得佣金奖励</span
                  >
                </div>
              </a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="设置佣金">
            <a-radio-group
              v-decorator="[
                'service_fee_type',
                { rules: [{ required: true, message: '请选择职位属性' }] },
              ]"
              @change="changeServiceType"
            >
              <a-radio :value="1">按年薪比例</a-radio>
              <a-radio :value="2">具体金额</a-radio>
            </a-radio-group>
            <a-input
              style="width: 80%"
              :placeholder="
                service_fee_type == 1 ? '请输入年薪比例' : '请输入具体金额'
              "
              v-decorator="[
                'service_fee_value',
                { rules: [{ required: true, message: '请输入佣金值！' }] },
              ]"
              :addon-after="service_fee_type == 1 ? '%' : '元'"
              @input="calcCommission"
            />
          </a-form-item>
          <a-form-item label="人数要求">
            <a-input
              placeholder="请输入人员数量要求"
              style="width: 80%"
              v-decorator="[
                'quantity',
                {
                  rules: [{ required: true, message: '请输入人员数量要求！' }],
                },
              ]"
              addon-after="人"
              @input="calcCommission"
            />
            <div class="tip" style="color: #999; font-size: 12px">
              说明：猎头推荐同一候选人只能获得一次佣金
            </div>
          </a-form-item>
          <a-form-item label="佣金总额">
            {{ commission.service_fee_total || 0 }}
          </a-form-item>
        </template>
        <template v-if="job_attribute === '3' || job_attribute === '4'">
          <DividerBar text="招聘服务"></DividerBar>
          <a-form-item label="设置服务费">
            <a-radio-group
              v-decorator="[
                'service_fee_type',
                { rules: [{ required: true, message: '请设置服务费' }] },
              ]"
              @change="changeServiceType"
            >
              <a-radio :value="1">按岗位工资比例</a-radio>
              <a-radio :value="2">具体金额</a-radio>
            </a-radio-group>
            <a-input
              style="width: 80%"
              :placeholder="
                service_fee_type == 1
                  ? '请输入按岗位工资比例'
                  : '请输入具体金额'
              "
              v-decorator="[
                'service_fee_value',
                { rules: [{ required: true, message: '请输入佣金值！' }] },
              ]"
              :addon-after="service_fee_type == 1 ? '%' : '元'"
              @input="calcCommission"
            />
          </a-form-item>
          <a-form-item label="招收人数">
            <a-input
              placeholder="请输入招收人数，1-99999"
              style="width: 80%"
              v-decorator="[
                'quantity',
                { rules: [{ required: true, message: '请输入招收人数' }] },
              ]"
              addon-after="人"
              @input="calcCommission"
            />
            <div class="tip" style="color: #999; font-size: 12px">
              说明：猎头推荐同一候选人只能获得一次佣金
            </div>
          </a-form-item>
          <a-form-item label="服务费金额">
            {{ commission.service_fee_total || 0 }}
          </a-form-item>
        </template>
        <DividerBar text="悬赏服务"></DividerBar>
        <a-form-item label="悬赏金额">
          <a-input
            placeholder="请输入悬赏金额"
            v-decorator="['company_reward_amount']"
            addon-after="元"
            @input="calcCommission"
          />
        </a-form-item>
        <a-form-item label="悬赏人数">
          <a-input
            placeholder="请输入悬赏人数"
            v-decorator="['company_reward_offered_num']"
            addon-after="人"
            @input="calcCommission"
          />
        </a-form-item>
        <a-form-item label="截至时间">
          <a-date-picker
            style="width: 73.2%"
            placeholder="请选择具体日期"
            v-decorator="['company_reward_deadline']"
          ></a-date-picker>
          <span style="color: #999; margin-left: 10px">(当天23:59:59)</span>
        </a-form-item>
        <a-form-item style="text-align: center" :wrapper-col="{ span: 24 }">
          <a-button
            style="width: 150px; margin-right: 20px"
            @click="$router.go(-1)"
          >
            上一步
          </a-button>
          <a-button type="primary" html-type="submit" style="width: 150px">
            下一步
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import DividerBar from "@/components/dividerBar";
import Api from "@/api";
import moment from "moment";
import api from "@/api";

export default {
  name: "PostService",
  components: {
    DividerBar,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      service_fee_type: "",
      job_attribute: "", // 2 全职 3 兼职
      job_id: "",
      basic_salary: 0,
      basic_salary_period: 0,
      commission: {
        hunter_commission_amount: 0, //猎头佣金
        platform_commission_rate: 0, //平台抽佣
        platform_commission_amount: 0, //抽佣金额
        layer_value: 0, //躺赚金额
        platform_reward_commission_amount: 0, //分成金额
        company_reward_finally_value: 0, //最终赏金
      },
    };
  },
  mounted() {
    this.job_attribute = this.$route.query.job_attribute;
    // this.job_id = this.$route.query.job_id
    this.basic_salary = this.$route.query.basic_salary;
    this.basic_salary_period = this.$route.query.basic_salary_period;
    console.log(this.basic_salary, "基本薪资");
  },
  methods: {
    async calcCommission() {
      let formData = this.form.getFieldsValue();
      let params = {
        ...formData,
        // job_id: this.job_id,
        hunter_salary_max: JSON.parse(sessionStorage.getItem("create_form")).hunter_salary_max,
        job_attribute: this.job_attribute,
        service_fee_type: this.service_fee_type,
      };
      if (this.job_attribute === "3" || this.job_attribute === "4") {
        params.basic_salary = this.basic_salary;
        params.basic_salary_period = this.basic_salary_period;
      }
      let res = await Api.post.createCalcCommission(params);
      this.commission = res;
      this.commission.service_fee_total = Number(res.service_fee_total).toFixed(
        2
      );
    },
    changeServiceType(e) {
      this.service_fee_type = e.target.value;
      // this.calcCommission()
    },
    handleSubmit(e) {
      e.preventDefault();
      let that = this;
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          let createForm = JSON.parse(sessionStorage.getItem("create_form"));
          createForm.service_fee_type = values.service_fee_type;
          createForm.recruit_service_type = values.recruit_service_type;
          let job = await Api.post.createPost(createForm);
          console.log(job, "job");
          this.job_id = job && job.job_id;
          values.company_reward_deadline =
            values.company_reward_deadline &&
            moment(values.company_reward_deadline).format("YYYY-MM-DD");
          let params = {
            ...values,
            job_id: this.job_id,
          };
          console.log(params, "params");
          try {
            let res = await Api.post.createTransaction(params);
            if (res && res.job_id) {
              let resp = await Api.post.payServiceFee({
                job_id: this.job_id,
                job_transaction_id: res.id,
                amount: res.amount,
                payment_method: "3",
              });
                    that.$router.push({
                      path: "/post-supplement",
                      query:{
                       job_id: this.job_id,
                       job_attribute:this.job_attribute
                      }
                    });
              // that.$info({
              //   title: "提交成功",
              //   content: "职位信息已提交成功，等待平台审核通过后即可上线",
              //   okText: "知道了",
              //   onOk() {
              //     if (that.job_attribute === "2") {
              //       that.$router.push({
              //         path: "/post",
              //       });
              //     } else if (that.job_attribute === "4") {
              //       that.$router.push({
              //         path: "/money-task",
              //       });
              //     } else {
              //       that.$router.push({
              //         path: "/flexible-post",
              //       });
              //     }
              //   },
              // });
            }
          } catch (error) {}
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.create {
  .header-timeline {
    margin: 50px auto;
    width: 45%;
  }
  .service-type {
    padding-left: 25px;
    margin-bottom: 15px;
    .item-img {
      display: inline-block;
      width: 60px;
      height: 60px;
    }
    .item-text {
      font-size: 20px;
      font-weight: bolder;
      line-height: 63px;
    }
    // test、
    ::v-deep .ant-radio-wrapper {
      box-sizing: border-box;
      padding: 10px 20px 0;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
    }
    ::v-deep .ant-radio-wrapper-checked {
      border-color: #35b5fe;
    }
  }
  .content {
    margin: 0 auto;
    width: 70%;
    .radio-tip {
      font-size: 12px;
      color: #999;
      margin-top: 3px;
    }
  }
}
</style>